import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { ISnAuthConfig } from '../interfaces';
import { SN_AUTH_CONFIG } from '../providers';

@Injectable()
export class SignUpEnabledGuard implements CanActivate {
  constructor(@Inject(SN_AUTH_CONFIG) private readonly _config: ISnAuthConfig) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this._config.signUpEnabled;
  }
}
